import { DropdownOptions } from '@components/common/formControl/dropdown';

export const defaultAddMdpMeetingInitialValues: IDefaultAddMdpMeetingFormInitialValues = {
	meetingType: '',
	meetSubCategory: '',
	cmdi: '',
	mdicode_c: '',
	assigned_cmdi_c: '',
	cmditownlist_c: [],
	plan_budget_c: '',
	participantspermeeting_c: null,
	monthname_c: '',
	financial_year_c: '',
	town_c: '',
	no_of_participants: null,
};

export const SocialMeetType = ['Social Meets', 'OTHER SOCIAL ACTIVITIES'];

export interface IDefaultAddMdpMeetingFormInitialValues {
	meetingType: string | null | undefined;
	meetSubCategory: string | null | undefined;
	cmdi: string | null | undefined;
	mdicode_c: string | null | undefined;
	assigned_cmdi_c: string | null | undefined;
	cmditownlist_c: DropdownOptions[];
	plan_budget_c: string | null | undefined;
	participantspermeeting_c: number | null | undefined;
	monthname_c: string | null | undefined;
	financial_year_c: string | null | undefined;
	focus_product_1?: string | null | undefined;
	town_c: string | null | undefined;
	no_of_participants?: number | null | undefined;
}

export interface RBDMClubOption {
	id: string;
	value: string;
	sfid: string;
	name: string;
	assigned_cmdi: string;
}

export const PRODUCT_SPECIFIC_MEETS = ['product specific user events', 'fcc product awareness meet'];
